import { createContext, useContext, useEffect, useMemo, useState } from "react";
import translations, { LANGUAGES } from "@/i18n/translations";

const SUPPORTED = LANGUAGES.map((l) => l.code);
const STORAGE_KEY = "novi-hotel-lang";

function detectInitialLanguage() {
  if (typeof window === "undefined") return "it";
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
  } catch (_) {}
  const browser = (navigator.language || "it").slice(0, 2).toLowerCase();
  return SUPPORTED.includes(browser) ? browser : "it";
}

const LanguageContext = createContext({
  lang: "it",
  setLang: () => {},
  t: translations.it,
  languages: LANGUAGES,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLanguage);

  useEffect(() => {
    try {
      window.localStorage.setItem(STORAGE_KEY, lang);
    } catch (_) {}
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({
      lang,
      setLang: (code) => {
        if (SUPPORTED.includes(code)) setLangState(code);
      },
      t: translations[lang] || translations.it,
      languages: LANGUAGES,
    }),
    [lang]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
